import CONSTANTS from './constants';
import tablesReducer from './tables';
import filtersReducer from './filters';

const {
	ACTION_NAMES
} = CONSTANTS;

export const getSubReducer = (state, action) => {
  if(action.type.indexOf('QUAL_TABLE/FILTER/') === 0){
    return filtersReducer(state, action);
  }

  if(action.type.indexOf('QUAL_TABLE/TABLE/') === 0){
	return tablesReducer(state, action);
  }

  return state;
};


// WEBPACK FOOTER //
// ./components/qual/Table/ducks/utils.js